import { PublicGroupStatus } from '../types';

export const PUBLIC_GROUPS_STATUSES: {[key in PublicGroupStatus]: string} = {
  pending: 'PENDING',
  accepted: 'ACCEPTED',
  rejected: 'REJECTED',
};
